import { Avatar, Box, Popover, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logout } from "@mui/icons-material";
import {
  selectProfile,
  selectProfilePictureBase64,
} from "../store/profile/selector";
import { setProfile, setProfilePictureBase64 } from "../store/profile/slice";

export function AvatarMenu() {
  const profilePicture = useSelector(selectProfilePictureBase64);
  const profileData = useSelector(selectProfile);
  const dispatch = useDispatch();
  const [openLogout, setOpenLogout] = useState(false);
  const [logoutPopOver, setLogoutPopOver] = useState<any>();
  const open = Boolean(logoutPopOver);
  const id = open ? "simple-popover" : undefined;
  const navigate = useNavigate();
  return (
    <>
      <Avatar
        alt="Remy Sharp"
        src={profilePicture}
        onClick={(e) => {
          setLogoutPopOver(e.currentTarget);
          setOpenLogout(true);
        }}
      />
      <Popover
        id={id}
        open={openLogout}
        anchorEl={logoutPopOver}
        onClose={() => {
          setOpenLogout(false);
          setLogoutPopOver(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className="text-white text-2xl flex flex-col"
      >
        <Box className="flex p-5 gap-5 items-center">
          <Avatar src={profilePicture} className="w-16 h-full" />
          <Box className="flex flex-col gap-2">
            <Typography className="font-bold text-xl">
              {profileData?.binusianName}
            </Typography>
            <Typography className="text-sm">
              {profileData?.binusianId}
            </Typography>
          </Box>
        </Box>
        <Box
          className="px-5 py-4 cursor-pointer border-t-2 flex gap-3"
          onClick={() => {
            dispatch(setProfile(null));
            dispatch(setProfilePictureBase64(""));
            navigate("/");
            setLogoutPopOver(null);
            setOpenLogout(false);
          }}
        >
          <Logout />
          <Typography>Logout</Typography>
        </Box>
      </Popover>
    </>
  );
}
